import { Component, inject, input } from '@angular/core';

import { BaseDeleteButtonComponent } from '../../../../../shared/base-classes/base-delete-button.component';
import { UltraMenuItemComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item/ultra-menu-item.component';
import { UltraMenuItemWrapperComponent } from '../../../../../shared/components/ultramarine-ui/ultra-menu-item-wrapper/ultra-menu-item-wrapper.component';
import { DialogsService } from '../../../../../shared/services/dialogs.service';
import { VehicleInsurancesService } from '../../vehicle-insurances.service';

@Component({
	selector: 'app-vehicle-insurance-delete-button',
	templateUrl: 'vehicle-insurance-delete-button.component.html',
	imports: [UltraMenuItemWrapperComponent, UltraMenuItemComponent],
})
export class VehicleInsuranceDeleteButtonComponent extends BaseDeleteButtonComponent {
	private _vehicleInsurancesService = inject(VehicleInsurancesService);
	private _dialogsService = inject(DialogsService);

	code = input<string>();

	onDelete() {
		this._dialogsService.openDeleteRecordDialog(
			{
				confirmed: () => {
					this._vehicleInsurancesService
						.deleteRecord(this.id())
						.subscribe((res) => {
							this.onDeleteCalled.emit(res);
						});
				},
			},
			this.code(),
		);
	}
}
